<template>
  <div class="pa-4">
    <h1>CREATE DINE-IN STORE</h1>
    <v-divider class="my-4"></v-divider>
    <v-form ref="formCreate">
      <div style="display: flex; flex-direction: column; margin-top: 20px">
        <v-layout
          wrap
          style="display: flex; padding-block: 10px; padding-inline: 20px"
        >
          <v-flex
            xs12
            sm6
            class="pa-2"
            style="display: flex; flex-direction: column; align-items: center"
          >
            <v-layout>
              <v-flex>
                <img
                  :src="storeProfileImage"
                  :style="{
                    width: height * 1.3 + 'px',
                    height: 220.17,
                    border: '1px solid gray',
                  }"
                  alt="Cropped Image"
                  v-if="storeProfileImage && storeProfileImage != null"
                />
                <v-card
                  flat
                  :height="220.17 + 'px'"
                  :width="height * 1.3 + 'px'"
                  color="#e9e9e9"
                  class="text-xs-center"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 6px;
                  "
                  v-else
                >
                  <v-card-text class="white--text">
                    <v-btn
                      icon
                      color="black"
                      @click="$refs.ProfileInput.click()"
                      ><v-icon color="white">add</v-icon></v-btn
                    >
                  </v-card-text></v-card
                >
              </v-flex>
            </v-layout>
            <div style="margin-bottom: 20px"></div>
            <v-layout>
              <v-flex>
                <v-btn
                  v-if="storeProfileImage && storeProfileImage != null"
                  @click="$refs.ProfileInput.click()"
                  >Choose Files</v-btn
                >
                <input
                  style="display: none"
                  type="file"
                  @change="onProfileImageSelected"
                  ref="ProfileInput"
                  accept="image/*"
                />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="pa-2"
            style="display: flex; flex-direction: column"
          >
            <v-layout wrap>
              <v-flex xs12 sm6 class="pa-1">
                <p class="info-header" style="margin-bottom: 0px">Store Type</p>
                <v-select
                  multiple
                  v-model="storeType"
                  :items="store_type"
                  item-text="store_type_name_th"
                  item-value="store_type_id"
                  menu-props="auto"
                  label="Select"
                  hide-details
                  single-line
                  required
                  :loading="isLoadingStoreType"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <p class="info-header" style="margin-bottom: 0px">
                  Store Category
                </p>
                <v-select
                  multiple
                  v-model="storeCategories"
                  :items="store_category"
                  item-text="store_category_name_th"
                  item-value="store_category_id"
                  menu-props="auto"
                  label="Select"
                  hide-details
                  single-line
                  required
                  :loading="isLoadingCategory"
                >
                </v-select>
              </v-flex>
              <div style="margin-inline: 10px"></div>
            </v-layout>
            <div style="margin-bottom: 40px"></div>
            <v-layout>
              <v-flex>
                <p class="info-header">Store Recommend</p>
                <v-radio-group row v-model="storeRecommend" color="#fddf00">
                  <v-radio :label="`Yes`" :value="1" color="#fddf00"></v-radio>
                  <v-radio :label="`No`" :value="0" color="#fddf00"></v-radio>
                </v-radio-group>
              </v-flex>
              <div style="margin-inline: 20px"></div>
              <v-flex>
                <p class="info-header">Store Best Seller</p>
                <v-radio-group row v-model="storeBestSeller">
                  <v-radio :label="`Yes`" :value="1" color="#fddf00"></v-radio>
                  <v-radio :label="`No`" :value="0" color="#fddf00"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-dialog v-model="collect_store_images_dialog" max-width="65vw">
          <v-card>
            <imageCropper
              :aspectRatio="480 / 320"
              :imageName="selectedFile.store_img_name"
              :imgSrc="storeImageTemp"
              :height="300"
              @close="collect_store_images_dialog = false"
              @setImageName="selectedFile.store_img_name = $event"
              @getCroped="getCollectCropped($event)"
              v-if="storeImageTemp != ''"
            ></imageCropper>
          </v-card>
        </v-dialog>
        <v-dialog v-model="store_images_dialog" max-width="65vw">
          <v-card>
            <imageCropper
              :aspectRatio="480 / 320"
              :imageName="selectedFile.store_img_name"
              :imgSrc="storeImageTemp"
              :height="300"
              @close="store_images_dialog = false"
              @setImageName="selectedFile.store_img_name = $event"
              @getCroped="getProfileCropped($event)"
              v-if="storeImageTemp != ''"
            ></imageCropper>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deleteImgDialog" max-width="30vw">
          <v-card>
            <v-card-title class="headline yellow lighten-2" primary-title>
              Delete Image
            </v-card-title>

            <v-card-text style="font-size: 1.35rem; margin-block: 15px">
              Are you sure to permanent delete this image?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat @click="deleteImgDialog = false">
                Cancel
              </v-btn>
              <v-btn color="primary" flat @click="deleteStoreImage">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div
          style="
            margin-top: 20px;
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex justify-start>
              <p class="info-header">Store Name (Thai)</p>
              <v-text-field
                solo
                required
                v-model="storeNameTH"
                :rules="storeNameRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex justify-start>
              <p class="info-header">Store Name (English)</p>
              <v-text-field
                solo
                required
                v-model="storeNameEN"
                :rules="storeNameRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex>
              <p class="info-header">Store Address TH</p>
              <v-text-field
                solo
                required
                v-model="storeAddressTH"
                :rules="storeNameRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex>
              <p class="info-header">Store Address EN</p>
              <v-text-field
                solo
                required
                v-model="storeAddressEN"
                :rules="storeNameRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex>
              <p class="info-header">Store Description TH</p>
              <v-textarea
                v-model="storeDescriptionTH"
                solo
                required
                counter="255"
                :rules="[
                  (v) => v.length <= 255 || 'Character must less than 256',
                ]"
              >
              </v-textarea>
            </v-flex>
          </v-layout>
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex>
              <p class="info-header">Store Description EN</p>
              <v-textarea
                v-model="storeDescriptionEN"
                solo
                required
                counter="255"
                :rules="[
                  (v) => v.length <= 255 || 'Character must less than 256',
                ]"
              >
              </v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex>
              <p class="info-header">Store Telephone Number</p>
              <v-text-field
                v-model="storeTel"
                solo
                required
                :rules="storeTelRules"
                mask="###-###-####"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <!-- <div style="margin-left: 40px; margin-right: 10px"></div> -->
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex>
              <p class="info-header">Store Email</p>
              <v-text-field
                v-model="storeEmail"
                solo
                required
                :rules="emailRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex>
              <p class="info-header">Store Table Amount</p>
              <v-text-field
                v-model="storeTableAmount"
                @keypress="isNumberWithoutDot($event)"
                solo
                required
                :rules="storeTableAmountRules"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex>
              <p class="info-header">Store Commission (%)</p>
              <v-text-field
                v-model="storeCommission"
                @keypress="onlyDoubleNoNegative($event, storeCommission)"
                solo
                required
                :rules="storeCommissionRules"
                suffix="%"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex xs12 md6>
              <p class="info-header">Store Period Time (Minute)</p>
              <v-text-field
                type="number"
                v-model="storePeriodTime"
                @keypress="isNumberWithoutDot($event)"
                solo
                required
                :rules="storePeriodTimeRules"
                style="padding-right: 30px"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <p class="info-header">Upload Store Image</p>
          <div>
            <v-btn
              @click="$refs.LogoInput.click()"
              color="primary"
              style="color: black"
              >UPLOAD IMAGE</v-btn
            >
            <input
              style="display: none"
              type="file"
              @change="onCollectImageSelected"
              ref="LogoInput"
              accept="image/*"
            />
          </div>
        </div>

        <div style="padding-inline: 20px">
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              padding-top: 20px;
              padding-bottom: 30px;
              padding-inline: 20px;
              background-color: #fddf0016;
              border-radius: 10px;
              border: 2px dashed #80808054;
              min-height: 150px;
            "
          >
            <v-layout row wrap align-center justify-space-around>
              <v-flex md4 v-for="(image, index) in storeImage" :key="index">
                <v-layout>
                  <v-flex
                    style="
                      display: flex;
                      justify-content: center;
                      margin-top: 20px;
                    "
                  >
                    <div
                      style="width: 20vw; height: 220.17px; position: relative"
                    >
                      <v-btn
                        fab
                        dark
                        small
                        color="red"
                        style="position: absolute; top: 5px; right: 5px"
                        @click="openDeleteStoreImageIndex(index)"
                      >
                        <v-icon color="white">delete</v-icon>
                      </v-btn>
                      <img
                        :src="image.store_img"
                        :style="{
                          width: 20 + 'vw',
                          height: 220.17,
                          border: '5px dashed white',
                        }"
                        alt="Cropped Image"
                        v-if="image.store_img && image.store_img != null"
                      />
                      <v-card
                        :height="220.17 + 'px'"
                        :width="height * 1.3 + 'px'"
                        color="grey"
                        class="text-xs-center pt-3"
                        v-else
                      >
                        No image</v-card
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
            margin-top: 20px;
          "
        >
          <div class="info-header">Store Daily Close/Open</div>
        </div>
        <div style="padding-bottom: 20px">
          <v-layout row wrap>
            <v-flex xs12 class="pl-4">
              <section
                id="subsec01"
                v-for="(item, index) in storeTime"
                :key="index"
              >
                <v-layout
                  wrap
                  row
                  justify-start
                  v-if="
                    item.store_period == 1 ||
                    (item.store_period == 2 && item.more == true)
                  "
                >
                  <v-flex xs12 sm1 style="margin-top: 20px; text-align: center">
                    <span v-if="item.store_period == 1">{{ item.days }}</span>
                  </v-flex>
                  <v-flex xs12 sm4 class="text-xs-center">
                    <vue-timepicker
                      v-model="item.store_time_open"
                      format="HH:mm"
                      :minute-interval="15"
                      class="timePicker innerstore-timepicker"
                      v-if="dialog == true"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex xs12 sm1 style="margin-top: 20px; text-align: center">
                    <span>to</span>
                  </v-flex>
                  <v-flex xs12 sm4 class="text-xs-center">
                    <vue-timepicker
                      v-model="item.store_time_close"
                      :minute-interval="15"
                      class="timePicker innerstore-timepicker"
                      v-if="dialog == true"
                    ></vue-timepicker>
                  </v-flex>
                  <v-flex
                    xs12
                    sm2
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <v-icon
                      v-if="
                        item.store_period == 1 &&
                        storeTime[index + 1].more == false
                      "
                      large
                      class="mt-3"
                      color="green"
                      @click="storeTime[index + 1].more = true"
                      >add_box</v-icon
                    >

                    <v-icon
                      v-if="item.store_period == 2"
                      large
                      class="mt-3"
                      color="red"
                      @click="indeterminateTime(item)"
                      >indeterminate_check_box
                    </v-icon>
                  </v-flex>
                </v-layout>
                <v-divider
                  class="my-2"
                  v-if="
                    item.store_period == 1 ||
                    (item.store_period == 2 && item.more == true)
                  "
                ></v-divider>
              </section>
            </v-flex>
          </v-layout>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            padding-block: 10px;
            padding-inline: 20px;
            margin-top: 40px;
          "
        >
          <v-layout>
            <v-flex>
              <p class="info-header">Store Province</p>
              <v-select
                v-model="storeProvince"
                :items="provinceData"
                item-text="province_name_th"
                item-value="province_id"
                menu-props="auto"
                label="Select"
                hide-details
                single-line
                @change="getDistrict()"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <div style="margin-inline: 20px"></div>
          <v-layout>
            <v-flex>
              <p class="info-header">Store District</p>
              <v-select
                v-model="storeDistrict"
                :items="district"
                item-text="district_name_th"
                item-value="district_id"
                menu-props="auto"
                label="Select"
                hide-details
                single-line
                @change="getSubAndZip()"
                :disabled="storeProvince == '' ? true : false"
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          padding-block: 10px;
          padding-inline: 20px;
          margin-top: 20px;
        "
      >
        <v-layout>
          <v-flex>
            <p class="info-header">Store Sub-District</p>
            <v-select
              v-model="storeSubDistrict"
              :items="sub_district"
              item-text="sub_district_name_th"
              item-value="sub_district_id"
              menu-props="auto"
              label="Select"
              hide-details
              single-line
              :disabled="storeDistrict == '' ? true : false"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <div style="margin-inline: 20px"></div>
        <v-layout>
          <v-flex>
            <p class="info-header">Store Zipcode</p>
            <v-select
              v-model="storeZipcode"
              :items="zipcode"
              item-text="zipcode_code"
              item-value="zipcode_id"
              menu-props="auto"
              label="Select"
              hide-details
              single-line
              :disabled="storeDistrict == '' ? true : false"
            >
            </v-select>
          </v-flex>
        </v-layout>
      </div>

      <div
        style="
          margin-inline: 20px;
          background-color: #fddf0016;
          margin-top: 40px;
          padding-bottom: 20px;
        "
      >
        <p
          class="info-header"
          style="
            background-color: #fddf00;
            width: 100%;
            padding-inline: 10px;
            padding-block: 15px;
            font-size: 1.8rem;
          "
        >
          Store Location
        </p>
        <div
          style="
            display: flex;
            align-items: flex-start;
            padding-block: 10px;
            padding-inline: 20px;
          "
        >
          <v-layout>
            <v-flex>
              <v-layout>
                <v-flex>
                  <p class="info-header">Store Latitude</p>
                  <v-text-field
                    solo
                    required
                    v-model="storeLat"
                    v-on:keypress="onlyDoubleForLocation($event, storeLat)"
                    :rules="latRules"
                  >
                  </v-text-field>
                </v-flex>
                <div style="margin-inline: 20px"></div>
                <v-flex>
                  <p class="info-header">Store Longitude</p>
                  <v-text-field
                    solo
                    required
                    v-model="storeLng"
                    v-on:keypress="onlyDoubleForLocation($event, storeLng)"
                    :rules="lngRules"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  margin-bottom: 20px;
                "
              >
                <v-btn @click="resetLocation"> Reset Location </v-btn>
                <v-btn @click="change++"> Edit Location </v-btn>
              </div>
              <GoogleMap
                :latitude="parseFloat(storeLat)"
                :longitude="parseFloat(storeLng)"
                :mapType="'latandlong'"
                :zoom="15"
                :draggable="true"
                @draged="getDragLocation($event)"
                :change="change"
              >
              </GoogleMap>
            </v-flex>
          </v-layout>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;

          margin-top: 40px;
        "
      >
        <v-btn
          @click="createDineInStore"
          color="#fddf00"
          style="max-width: 300px; width: 60vw"
          ><v-icon color="black" class="mr-2">add</v-icon> Create Store
        </v-btn>
      </div>
    </v-form>
    <v-dialog v-model="error_dialog" persistent max-width="500">
      <v-card>
        <div
          style="
            background-color: #fddf00;
            height: 60px;
            display: flex;
            align-items: center;
            padding-left: 20px;
          "
        >
          <v-icon large style="margin-right: 10px" color="black"
            >warning</v-icon
          >
          <div style="font-size: 1.8rem">Warning</div>
        </div>
        <v-card-title class="headline" primary-title>{{
          error_text
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="success_dialog" max-width="350">
      <v-card style="border-radius: 20px">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-block: 30px;
          "
        >
          <v-icon
            x-large
            style="margin-bottom: 10px; font-size: 70px"
            color="primary"
            >check_circle</v-icon
          >
          <div style="font-size: 1.8rem">Create Success</div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="success_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="failed_dialog" max-width="350">
      <v-card style="border-radius: 20px">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-block: 30px;
          "
        >
          <v-icon
            x-large
            style="margin-bottom: 10px; font-size: 70px"
            color="red"
            >close</v-icon
          >
          <div style="font-size: 1.8rem">Create Failed</div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="failed_dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GoogleMap from "@/components/Plugins/GoogleMap.vue";
import imageCropper from "@/components/Plugins/imageCropper.vue";
import imageUploader from "@/components/back-office/StoreManagement/ImageUploader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data: () => ({
    valid: false,
    change: 0,
    dialog: true,
    storeType: [],
    storeCategories: [],
    storeNameTH: "",
    storeNameEN: "",
    storeAddressTH: "",
    storeAddressEN: "",
    storeDescriptionTH: "",
    storeDescriptionEN: "",
    storeTel: "",
    storeEmail: "",
    storeProvince: "",
    storeDistrict: "",
    storeSubDistrict: "",
    storeZipcode: "",
    storeRecommend: 1,
    storeBestSeller: 1,
    height: 300,
    error_dialog: false,
    collect_store_images_dialog: false,
    store_images_dialog: false,
    success_dialog: false,
    failed_dialog: false,
    change_image: 0,
    storeImageTemp: "",
    error_text: "",
    selectedFile: {
      store_img: "",
      store_img_name: "",
    },
    storeProfileImage: "",
    storeImage: [],
    deleteImgDialog: false,
    deleteImageIndex: 0,
    storeStatus: false,
    storeLat: "",
    storeLng: "",
    removeStoreImage: [],
    storeTableAmount: "",
    storeCommission: "",
    storePeriodTime: "",
    storeTime: [
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 1,
        store_period: 1,
        more: false,
        days: "Sun",
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 1,
        store_period: 2,
        more: false,
        days: "Sun",
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 2,
        days: "Mon",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 2,
        days: "Mon",
        store_period: 2,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 3,
        days: "Tue",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 3,
        days: "Tue",
        store_period: 2,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 4,
        days: "Wed",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 4,
        days: "Wed",
        store_period: 2,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 5,
        days: "Thu",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 5,
        days: "Thu",
        store_period: 2,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 6,
        days: "Fri",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 6,
        days: "Fri",
        store_period: 2,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 7,
        days: "Sat",
        store_period: 1,
        more: false,
      },
      {
        store_time_open: "",
        store_time_close: "",
        store_day: 7,
        days: "Sat",
        store_period: 2,
        more: false,
      },
    ],
    store_type: [],
    store_category: [],
    store_package: [],
    province: [],
    district: [],
    sub_district: [],
    zipcode: [],
    storeNameRules: [(v) => !!v || "Store name is required"],
    storeAddressRules: [(v) => !!v || "Store address is required"],
    storeTelRules: [
      (v) => {
        if (v === "") {
          return "Store telephone number is required";
        } else {
          return true;
        }
      },
      (v) => {
        if (v == "") {
          return "";
        }
        if (v.charAt(0) === "0") {
          if (v.length > 10) {
            return "Store telephone number is invalid.";
          } else if (v.length < 10) {
            return "Store telephone number must be 10 charecter length.";
          } else {
            return true;
          }
        } else {
          if (v.length > 9) {
            return "Store telephone number is invalid";
          } else if (v.length < 9) {
            return "Store telephone number must be 9 charecter length.";
          } else {
            return true;
          }
        }
      },
    ],
    emailRules: [
      (v) => {
        if (/.+@.+/.test(v)) {
          return true;
        } else if (v === "") {
          return true;
        } else {
          return "E-mail is invalid";
        }
      },
    ],
    storeTableAmountRules: [
      (v) => {
        if (v === "") {
          return "Store Table Amount is required";
        } else {
          return true;
        }
      },
    ],
    storePeriodTimeRules: [
      (v) => {
        if (v === "") {
          return "Store Period Time is required";
        } else {
          return true;
        }
      },
    ],
    storeCommissionRules: [
      (v) => {
        if (v === "") {
          return "Store Commission is required";
        } else {
          return true;
        }
      },
      (v) => {
        if (parseInt(v) > 100) {
          return "Store Commission must be between 0-100";
        } else {
          return true;
        }
      },
    ],
    latRules: [
      (v) => {
        const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
        return pattern.test(v) || "Invalid";
      },
      (v) => {
        if (parseFloat(v) > 90 || parseFloat(v) < -90) {
          return "Store latitude must be between -90 and 90";
        } else {
          return true;
        }
      },
    ],
    lngRules: [
      (v) => {
        const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
        return pattern.test(v) || "Invalid";
      },
      (v) => {
        if (parseFloat(v) > 180 || parseFloat(v) < -180) {
          return "Store latitude must be between -180 and 180";
        } else {
          return true;
        }
      },
    ],
    isLoadingCategory: false,
    isLoadingStoreType: false,
  }),
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      packageItems: (state) => state.fetchPackageBack.package_data,
    }),
  },
  components: { GoogleMap, imageCropper, imageUploader, VueTimepicker, moment },
  methods: {
    isNumberWithoutDot(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (evt.keyCode == 110 || evt.keyCode == 190) {
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    onlyDouble(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
    },
    onlyDoubleNoNegative(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57 || charCode == 45)) {
        if (charCode != 46) e.preventDefault();
      }
    },
    onlyDoubleForLocation(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      const countDash = (cha.match(/\-/g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      if (countDash > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (charCode == 46 || charCode == 45) {
        } else {
          e.preventDefault();
        }
      }
    },

    indeterminateTime(item) {
      item.more = false;
      item.store_time_close = "";
      item.store_time_open = "";
    },
    getDragLocation(val) {
      this.storeLat = val.lat;
      this.storeLng = val.lng;
    },
    resetLocation() {
      this.storeLat = "";
      this.storeLng = "";
      this.change++;
    },
    getCollectCropped(image_value) {
      this.selectedFile.store_img = image_value;
      this.storeImage.push({
        store_img: this.selectedFile.store_img,
        store_img_name: this.selectedFile.store_img_name,
      });
      this.selectedFile = { store_img: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    getProfileCropped(image_value) {
      this.storeProfileImage = image_value;
      this.selectedFile = { store_img: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    openDeleteStoreImageIndex(index) {
      this.deleteImgDialog = true;
      this.deleteImageIndex = index;
    },
    onProfileImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    onCollectImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.collect_store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async createDineInStore() {
      if (!this.$refs.formCreate.validate()) return;
      if (this.storeProfileImage === "") {
        this.error_text = "Please upload store profile image.";
        this.error_dialog = true;
        return;
      }
      if (this.storeType.length == 0) {
        this.error_text = "Please select store type.";
        this.error_dialog = true;
        return;
      }

      if (this.storeCategories.length == 0) {
        this.error_text = "Please select store category.";
        this.error_dialog = true;
        return;
      }

      if (this.storeNameTH === "") {
        this.error_text = "Please enter store name (Thai).";
        this.error_dialog = true;
        return;
      }
      if (this.storeNameEN === "") {
        this.error_text = "Please enter store name (English).";
        this.error_dialog = true;
        return;
      }
      if (this.storeAddressTH === "") {
        this.error_text = "Please enter store address (Thai).";
        this.error_dialog = true;
        return;
      }
      if (this.storeAddressEN === "") {
        this.error_text = "Please enter store address (English).";
        this.error_dialog = true;
        return;
      }
      if (this.storeRecommend === "") {
        this.error_text = "Please enter store recommend.";
        this.error_dialog = true;
        return;
      }
      if (this.storeProvince === "") {
        this.error_text = "Please select store province.";
        this.error_dialog = true;
        return;
      }
      if (this.storeDistrict === "") {
        this.error_text = "Please select store district.";
        this.error_dialog = true;
        return;
      }
      if (this.storeSubDistrict === "") {
        this.error_text = "Please select store sub district.";
        this.error_dialog = true;
        return;
      }
      if (this.storeZipcode === "") {
        this.error_text = "Please select store zip code.";
        this.error_dialog = true;
        return;
      }
      if (this.storeLat === "") {
        this.error_text = "Please enter store latitude.";
        this.error_dialog = true;
        return;
      }
      if (parseFloat(this.storeLat) < -90 || parseFloat(this.storeLat) > 90) {
        this.error_text = "Store latitude is invalid value.";
        this.error_dialog = true;
        return;
      }
      if (this.storeLng === "") {
        this.error_text = "Please enter store longitude.";
        this.error_dialog = true;
        return;
      }
      if (parseFloat(this.storeLng) < -180 || parseFloat(this.storeLng) > 180) {
        this.error_text = "Store longitude is invalid value.";
        this.error_dialog = true;
        return;
      }
      if (this.storeTel === "") {
        this.error_text = "Please enter store telephone number.";
        this.error_dialog = true;
        return;
      }
      if (this.storeTableAmount === "") {
        this.error_text = "Please enter store table amount.";
        this.error_dialog = true;
        return;
      }
      if (this.storeCommission === "") {
        this.error_text = "Please enter store commission.";
        this.error_dialog = true;
        return;
      }
      let storeImageList = [];
      for (let i = 0; i < this.storeImage.length; i++) {
        storeImageList.push({ image: this.storeImage[i].store_img });
      }

      for (let i = 0; i < this.storeTime.length; i++) {
        if (this.storeTime[i].store_time_open === null) {
          this.storeTime[i].store_time_open = "";
        }
        if (this.storeTime[i].store_time_close === null) {
          this.storeTime[i].store_time_close = "";
        }
        const open = new Date(
          "2022-10-26 " + this.storeTime[i].store_time_open
        );
        const close = new Date(
          "2022-10-26 " + this.storeTime[i].store_time_close
        );
        const res = moment(open).isAfter(close);
        if (res == true) {
          this.error_text = "Time's incorrect. Please check!";
          this.error_dialog = true;
          return;
        }
        // if (i % 2 === 1) {
        //   if (
        //     this.storeTime[i].store_time_close !== "00:00" &&
        //     this.storeTime[i].store_time_open !== "00:00"
        //   ) {
        //     const open2 = new Date(
        //       "2022-10-26 " + this.storeTime[i - 1].store_time_open
        //     );
        //     const close2 = new Date(
        //       "2022-10-26 " + this.storeTime[i - 1].store_time_close
        //     );
        //     const res2 = moment(open).isBefore(open2);
        //     const res3 = moment(close).isBefore(close2);
        //     const res4 = moment(close).isBefore(open2);
        //     const res5 = moment(open).isBefore(close2);
        //     if (res2 == true || res3 == true || res4 == true || res5 == true) {
        //       this.error_text = "Time's incorrect. Please check!";
        //       this.error_dialog = true;
        //       return;
        //     }
        //   }
        // }
      }

      var payload = {
        data: {
          store_types: this.storeType,
          store_categories: this.storeCategories,
          store_package: null,
          store_name_th: this.storeNameTH,
          store_name_en: this.storeNameEN,
          store_address_th: this.storeAddressTH,
          store_address_en: this.storeAddressEN,
          store_description_th: this.storeDescriptionTH,
          store_description_en: this.storeDescriptionEN,
          store_recommend: this.storeRecommend,
          store_best_seller: this.storeBestSeller,
          store_district: this.storeDistrict,
          store_sub_district: this.storeSubDistrict,
          store_zipcode: this.storeZipcode,
          store_lat: this.storeLat,
          store_long: this.storeLng,
          store_image: storeImageList || [],
          store_profile: this.storeProfileImage,
          store_province: this.storeProvince,
          store_tel: this.storeTel,
          store_rating: 0,
          store_email: this.storeEmail,
          store_approve: 1,
          store_status: 0,
          store_commission: parseFloat(this.storeCommission),
          store_table_amount: parseInt(this.storeTableAmount),
          store_period_table_time: this.storePeriodTime,
          store_time: this.storeTime,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/createDineInStore",
        payload
      );
      if (res === false) {
        this.failed_dialog = true;
      } else {
        this.success_dialog = true;
        this.resetData();
      }
    },
    resetData() {
      this.storeType = [];
      this.storeCategories = [];
      this.storeNameTH = "";
      this.storeNameEN = "";
      this.storeAddressTH = "";
      this.storeAddressEN = "";
      this.storeDescriptionTH = "";
      this.storeDescriptionEN = "";
      this.storeTel = "";
      this.storeEmail = "";
      this.storeProvince = "";
      this.storeDistrict = "";
      this.storeSubDistrict = "";
      this.storeZipcode = "";
      this.storeRecommend = 1;
      this.storeBestSeller = 1;
      this.storeImageTemp = "";
      this.error_text = "";
      this.storeProfileImage = "";
      this.storeImage = [];
      this.storeStatus = false;
      this.storeLat = "";
      this.storeLng = "";
      this.removeStoreImage = [];
      this.storeTableAmount = "";
      this.storeCommission = "";
    },
    selectNewProvince() {
      this.sub_district = [];
      this.storeSubDistrict = "";
      this.zipcode = [];
      this.storeZipcode = "";
    },
    async getDistrict() {
      this.district = [];
      this.storeDistrict = "";
      this.selectNewProvince();
      this.district = await this.$store.dispatch(
        "fetchProvinceBack/getDistrictCore",
        this.storeProvince
      );
    },
    async getStoreType() {
      this.isLoadingStoreType = true;
      this.store_type = await this.$store.dispatch(
        "fetchDineIn/getDineInStoreType"
      );
      this.isLoadingStoreType = false;
    },
    async getStoreCategory() {
      this.isLoadingCategory = false;
      this.store_category = await this.$store.dispatch(
        "fetchDineIn/fetchStoreCategory"
      );
      this.isLoadingCategory = false;
    },
    deleteStoreImage() {
      if (this.deleteImageIndex > -1) {
        this.storeImage.splice(this.deleteImageIndex, 1);
      }
      this.deleteImgDialog = false;
      this.removeStoreImage.push(this.deleteImageIndex);
      this.deleteImageIndex = 0;
    },
    async getSubDistrict() {
      // this.sub_district = [];
      // this.storeSubDistrict = "";
      this.sub_district = await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictCore",
        this.storeDistrict
      );
    },
    async getZipcode() {
      // this.zipcode = [];
      // this.storeZipcode = "";
      this.zipcode = await this.$store.dispatch(
        "fetchProvinceBack/getZipCodeCore",
        this.storeDistrict
      );
    },
    async getSubAndZip() {
      await this.getSubDistrict();
      await this.getZipcode();
    },

    async fetchData() {
      this.getStoreType();
      this.getStoreCategory();
      this.storeProvince = 66;
      this.store_package = await this.$store.dispatch(
        "fetchPackageBack/getPackageByProvince",
        "phuket"
      );
      this.district = await this.$store.dispatch(
        "fetchProvinceBack/getDistrictCore",
        this.storeProvince
      );
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style scoped>
.info-header {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
}

.timePicker {
  margin-top: 15px;
}

.time-picker input.display-time {
  border: none;
}

.innerstore-timepicker {
  border: 1px solid #d2d2d2;
  width: auto;
}

.innerstore-timepicker:hover {
  border: 1px solid #333;
}

.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #ffd600;
  color: black;
}

.time-picker input.display-time {
  width: 9.3em;
  color: rgba(0, 0, 0, 0.54);
}
</style>
